<template>
    <div class="person">
        <div class="person-out mt-30">
            <div v-for="item, index in list" :key="index"  class="person-out-for">
                <el-row class="person-out-for-list" :gutter="20">
                    <el-col :span="6" class="person-out-for-list-item">
                        <img class="item-image" :src="getImgSrc(item)" alt="">
                    </el-col>
                    <div @click="handleDetail(item.docId)" style="cursor:pointer">
                        <el-col :span="10" class="item-text">
                            <div class="text-name">{{item.name}}</div>
                            <div class="text-detail">{{item.company}}</div>
                            <div class="text-time">时间：{{item.showDate?item.showDate.substring(0, 10):''}}</div>
                        </el-col>
                    </div>
                </el-row>
                <div class="person-btn">
                        <button class="detal-button" @click="handleDetail(item.docId)">查看详情</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:'personage-list-wrapper',
    props:{
        list: {
            type: Array,
            default: () => ([]),
        },
    },
    data () {
        return {}
    },
    methods: {
        handleDetail(val){
            this.$emit('goDetail', val)
        },
        // 获取图片地址
        getImgSrc(info){
            let srcSource = null
            let imgInfo
            if (typeof info.content === "string") {
                srcSource = info.content.match(/src="([^"]*)"/g);
            }
            if (srcSource) {
                let imgList = srcSource[0].split('src=')
                imgInfo = imgList[1].replace("\"","").replace("\"","")
            }
            return imgInfo
        },
    }
}
</script>

<style lang="scss" scoped>
@import './Personage.scss'

</style>
